import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkErrorService {
  private retryCallback: (() => void) | null = null;
  private showSubject = new BehaviorSubject<boolean>(false);
  showError$ = this.showSubject.asObservable();

  show(retryCallback: () => void): void {
    this.retryCallback = retryCallback;
    this.showSubject.next(true);
  }

  retry(): void {
    this.showSubject.next(false);
    const cb = this.retryCallback;
    this.retryCallback = null;
    if (cb) cb();
  }

  hide(): void {
    this.retryCallback = null;
    this.showSubject.next(false);
  }
}
